import { render, staticRenderFns } from "./TransactionHistoryView.vue?vue&type=template&id=cd95d0fa&scoped=true&"
import script from "./TransactionHistoryView.vue?vue&type=script&lang=ts&"
export * from "./TransactionHistoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd95d0fa",
  null
  
)

export default component.exports